import React, { forwardRef } from "react";
import { cn } from "../../lib/utils.js";
import { CARD_EDGE_PADDING, useCardSize } from "./card-size.js";

/** The card's action row. Its padding follows the Card's `size`. */
export const CardFooter = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(function CardFooter({ className, children, ...rest }, ref) {
  const size = useCardSize();
  return (
    <div
      ref={ref}
      className={cn(
        "flex items-center justify-between gap-2 border-t border-pb-border/70 bg-pb-card-elevated",
        CARD_EDGE_PADDING[size],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});
